import React, { useEffect, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import Menu from "../ui/Menu";
import { ROUTES } from "../utils/Routes";
import { createScreen } from "../hooks/createScreen";
import { createModal } from "../hooks/createModal";
import { kbdEvent, runEvent } from "../utils/Utils";
import PrintOrderActivity from "./PrintOrderActivity";
import PrintSalesPeriod from "./PrintSalesPeriod";
import PrintInvoiceHistory from "./PrintInvoiceHistory";

export default function CustomerPrint(props) {

    const { controller = "", callback = () => { }, route = "", signal = {} } = props;
    const [data, setData] = useState(props.selected);
    const [selected, setSelected] = useState("1");
    const [loading, setLoading] = useState(false);
    const [align, setAlign] = useState("auto");
    const [message, setMessage] = useState("");
    const buffer = 10;

    const menu = [
        { value: "0", label: "For this customer:", disabled: true, text: "For this customer:" },
        { value: "back_order", label: "Backorder report", text: "Backorder report" },
        { value: "order_activity", label: "Order activity", text: "Order activity" },
        { value: "sales_for_period", label: "Sales for a period", text: "Sales for a period" },
        { value: "invoice_history", label: "Invoice history (no titles, just invoices)", text: "Invoice history (no titles, just invoices)" },
        { value: "send_email", label: `Send email to: ${data?.email || ""}`, text: `Send email to: ${data?.email || ""}` },
        { value: "1", label: "For all customers: ", disabled: true, text: "For all customers: " },
        { value: "export_email_list", label: "Generate an email list file for use by an external application", text: "Generate an email list file for use by an external application" },        
        { value: "export_select_fields", label: "Export select fields", text: "Export select fields" },
        { value: "frequent_buyer_reports", label: "Frequent Buyer Reports", text: "Frequent Buyer Reports" },
    ]

    const printOptions = (clickedItem) => {
        const value = clickedItem?.value || selected;
        const selectedItem = menu.find(item => item.value === value);
        if (!selectedItem?.disabled) {
            switch (value) {
                case "back_order":
                    setMessage(" Customer has no active orders");
                    break;
                case "order_activity":
                    window.bm_state.value = ROUTES.CUSTOMER.PRINT_ORDER_ACTIVITY;
                    createModal({
                        closable: true,
                        title: "Customer Order Activity",
                        component:
                            <PrintOrderActivity 
                                controller={controller} 
                                route={ROUTES.CUSTOMER.PRINT_ORDER_ACTIVITY} 
                            />,
                        callback: () => {
                            window.bm_state.value = ROUTES.CUSTOMER.PRINT;
                        },
                    })
                    break;
                case "sales_for_period":
                    window.bm_state.value = ROUTES.CUSTOMER.PRINT_SALES_PERIOD;
                    createModal({
                        closable: true,
                        title: "Enter period",
                        component:
                            <PrintSalesPeriod
                                controller={controller}
                                route={ROUTES.CUSTOMER.PRINT_SALES_PERIOD}
                            />,
                        callback: () => {
                            window.bm_state.value = ROUTES.CUSTOMER.PRINT;
                        },
                    })
                    break;
                case "invoice_history":
                    window.bm_state.value = ROUTES.CUSTOMER.PRINT_INVOICE_HISTORY;
                    createModal({
                        closable: true,
                        title: "Customer POS Invoicing History",
                        component:
                            <PrintInvoiceHistory
                                controller={controller}
                                route={ROUTES.CUSTOMER.PRINT_INVOICE_HISTORY}
                            />,
                        callback: () => {
                            window.bm_state.value = ROUTES.CUSTOMER.PRINT;
                        }
                    })
                    break;
                case "send_email":
                    if (data?.email) {
                        window.location.href = `mailto:${data.email}`;
                    } else {
                        setMessage("No email address available for this customer");
                    }
                    break;
                case "thermal_labels":
                    setMessage("Generating thermal labels...");
                    break;
                case "laser_labels":
                    setMessage("Generating laser labels...");
                    break;
                case "export_email_list":
                    setMessage("Generating email list...");
                    break;
                case "customer_list_detailed":
                    setMessage("Generating detailed customer list...");
                    break;
                case "customer_list_one_line":
                    setMessage("Generating one line customer list...");
                    break;
                case "customer_list_one_line_email":
                    setMessage("Generating one line with email customer list...");
                    break;
                case "export_select_fields":
                    setMessage("Generating export of select fields...");
                    break;
                case "frequent_buyer_reports":
                    setMessage("Generating frequent buyer reports...");
                break;
                default:
                    callback(value);
                break;
            }
        }
    }


    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: () => callback(false) },
            { 
                key: KBD.PAGE_UP, 
                action: () => { printOptions() }
            },
            { 
                key: KBD.ENTER, 
                action: () => { printOptions() }
            },
        ];
        const cleanup = listen(controller, route, actions);
        return cleanup;
    }, [selected])

    return (
        <div style={{ "width": "660px" }}>
            <div className="shim" /><div className="shim" />
            <Menu controller={controller} callback={printOptions} bordered keyName="value" setSelected={setSelected} selected={selected} menu={menu} route={route} />
            <div className="shim" /><div className="shim" />
            <Status><InfoIcon />{message}</Status>
        </div>
    )

}